import React, { ReactNode, useEffect, useState } from "react";
import useWindowDimensions from "../utils/useWindowDimensions";
import TableElement, { TableElementProps } from "./tableElement";

import "./table.css";
import { rearrangeArrayByPattern } from "../utils/arrayUtils";

interface TableProps {
    titles: string[];
    elements: (TableElementProps | string)[];
    className?: string;
    elementSwitch?: number[];
}

export default function Table(props: TableProps) {

    var titles = [...props.titles], elements = [...props.elements];

    const windowDimensions = useWindowDimensions();

    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        setMobile(windowDimensions.width < 900);
    }, [windowDimensions]);

    if(props.elementSwitch && mobile) {
        titles = rearrangeArrayByPattern(titles, props.elementSwitch);
        const elementChunks = [], chunkSeperator = [];
        let currentChunk = [];
        for(const element of elements) {
            if(typeof element === "string") {
                if(currentChunk.length > 0) {
                    elementChunks.push(currentChunk);
                    currentChunk = [];
                }
                chunkSeperator.push(element);
            } else {
                currentChunk.push(element);
            }
        }
        if(currentChunk.length > 0) {
            elementChunks.push(currentChunk);
        }
        elements = [];
        for(var i = 0; i < elementChunks.length; i++) {
            elements.push(...rearrangeArrayByPattern(elementChunks[i], props.elementSwitch));
            if(i < chunkSeperator.length) {
                elements.push(chunkSeperator[i]);
            }
        }
    }

    return <div className={"txoria-table " + (props.className || "") + (mobile ? " mobile" : "")}>
        {titles.map((title, index) => (
            <a key={index} className={"title" + (mobile && index >= titles.length/2 ? " blue" : "")}>
                {title}
            </a>
        ))}
        {elements.map((element, index) => {
            if (typeof element === "string") {
                return <h3 key={index}>{element}</h3>;
            } else {
                return (
                    <TableElement
                        className={element.className}
                        onClick={element.onClick}
                        blue={element.blue && mobile}
                        value={element.value as ReactNode}
                    />
                );
            }
        })}
    </div>;
}